import { useSPIntl } from 'hooks/useIntl';
import { useCallback } from 'react';

export type ValueWithUnit = {
  value: number;
  unit: string;
};

export function useValueWithUnitFormatter() {
  const { formatNumber } = useSPIntl();

  return useCallback(
    (data: ValueWithUnit | undefined | null) => {
      if (data?.value === null || data?.value === undefined) {
        return '';
      }
      const formattedValue = formatNumber(data?.value, { minimumFractionDigits: 2 });
      return (data.unit ?? false) ? `${formattedValue} ${data.unit}` : formattedValue;
    },
    [formatNumber],
  );
}

export function FormattedValueWithUnit({ value }: { value: ValueWithUnit }) {
  const formatValueWithUnit = useValueWithUnitFormatter();
  return <>{formatValueWithUnit(value)}</>;
}
